import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CourseService } from '../../services/course.service';
import { CreateCourseRequest } from '../../models/course.model';
import { ErrorHandlingService } from '../../services/error-handling.service';

@Component({
  selector: 'app-course-form',
  templateUrl: './course-form.component.html',
  styleUrls: ['./course-form.component.css']
})
export class CourseFormComponent implements OnInit {
  courseForm: FormGroup;
  isEditMode = false;
  courseId?: number;
  loading = false;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private courseService: CourseService,
    private errorHandling: ErrorHandlingService
  ) {
    this.courseForm = this.fb.group({
      subjectId: ['', Validators.required],
      name: ['', [Validators.required, Validators.minLength(3)]],
      code: ['', [Validators.required, Validators.minLength(2)]],
      description: [''],
      startDate: [''],
      endDate: [''],
      maxStudents: [50, [Validators.required, Validators.min(1)]]
    });
  }

  ngOnInit(): void {
    this.courseId = this.route.snapshot.params['id'];
    if (this.courseId) {
      this.isEditMode = true;
      this.loadCourse();
    }
  }

  loadCourse(): void {
    if (this.courseId) {
      this.loading = true;
      this.courseService.getCourseById(this.courseId).subscribe({
        next: (course) => {
          this.courseForm.patchValue({
            subjectId: course.subjectId,
            name: course.name,
            code: course.code,
            description: course.description,
            startDate: course.startDate,
            endDate: course.endDate,
            maxStudents: course.maxStudents
          });
          this.loading = false;
        },
        error: (error) => {
          this.errorHandling.handleError(error);
          this.loading = false;
        }
      });
    }
  }

  onSubmit(): void {
    if (this.courseForm.valid) {
      this.loading = true;
      const courseData: CreateCourseRequest = this.courseForm.value;

      if (this.isEditMode && this.courseId) {
        this.courseService.updateCourse(this.courseId, courseData).subscribe({
          next: () => {
            this.errorHandling.showSuccess('Course updated successfully');
            this.router.navigate(['/courses']);
          },
          error: (error) => {
            this.errorHandling.handleError(error);
            this.loading = false;
          }
        });
      } else {
        this.courseService.createCourse(courseData).subscribe({
          next: () => {
            this.errorHandling.showSuccess('Course created successfully');
            this.router.navigate(['/courses']);
          },
          error: (error) => {
            this.errorHandling.handleError(error);
            this.loading = false;
          }
        });
      }
    }
  }

  cancel(): void {
    this.router.navigate(['/courses']);
  }
}
